export enum CommonErrorCodeEnum {
  VALIDATION_FAILED = "VALIDATION_FAILED",
  BAD_REQUEST = "BAD_REQUEST",
  MISSING_REQUIRED_PARAMS = "MISSING_REQUIRED_PARAMS",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  NOT_FOUND = "NOT_FOUND",
  CONFLICT = "CONFLICT",
  PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
  UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
}

export const HTTP_STATUS_MAP: Record<CommonErrorCodeEnum, number> = {
  [CommonErrorCodeEnum.VALIDATION_FAILED]: 400,
  [CommonErrorCodeEnum.BAD_REQUEST]: 400,
  [CommonErrorCodeEnum.MISSING_REQUIRED_PARAMS]: 400,
  [CommonErrorCodeEnum.UNAUTHORIZED]: 401,
  [CommonErrorCodeEnum.FORBIDDEN]: 403,
  [CommonErrorCodeEnum.NOT_FOUND]: 404,
  [CommonErrorCodeEnum.CONFLICT]: 409,
  [CommonErrorCodeEnum.PAYLOAD_TOO_LARGE]: 413,
  [CommonErrorCodeEnum.UNSUPPORTED_MEDIA_TYPE]: 415,
  [CommonErrorCodeEnum.TOO_MANY_REQUESTS]: 429,
  [CommonErrorCodeEnum.INTERNAL_SERVER_ERROR]: 500,
  [CommonErrorCodeEnum.SERVICE_UNAVAILABLE]: 503,
};
